import React from 'react';
import { observer } from 'mobx-react-lite';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';
import { roundTimeStore } from '../../store/roundTimeStore';

export const TimeAnimSection = observer(({ isInExtra }) => {
  const { time } = roundTimeStore;
  const { duration } = roundInfoStore;

  if (!time) {
    return null;
  }

  return (
    <div className={isInExtra ? 'buy-sale-circle' : 'bet-on-poker-loader'}>
      <svg
        viewBox='0 0 33.83098862 33.83098862'
        width='100%'
        xmlns='http://www.w3.org/2000/svg'
        className='bet-on-poker-loader-svg'
      >
        <circle
          fill='none'
          r='14'
          cx='16.91549431'
          cy='16.91549431'
          strokeWidth='1'
          className={isInExtra ? 'circle-bg' : 'bet-on-poker-loader-circle-bg'}
          strokeLinecap='round'
        />
        <circle
          fill='none'
          r='14'
          cx='16.91549431'
          cy='16.91549431'
          strokeWidth='1'
          className={isInExtra ? 'circle' : 'bet-on-poker-loader-circle'}
          strokeLinecap='round'
          strokeDasharray={`${100 - (time / duration) * 100}, 360`}
        />
      </svg>
      <p className='bet-on-poker-loader-circle-txt'>{time}</p>
    </div>
  );
});
